import React from 'react';
import { Link } from 'react-router-dom';

// Henüz kullanıcıya açılmamış bölümler için (oyuncu profili vb.)
// gösterilen basit "çok yakında" ekranı.
const ComingSoon = () => {
    return (
        <div className="min-vh-100 d-flex flex-column justify-content-center align-items-center bg-light text-center px-3">
            <i className="fas fa-futbol fa-4x text-secondary opacity-25 mb-4"></i>
            <h2 className="fw-bold">Çok Yakında</h2>
            <p className="text-secondary" style={{ maxWidth: 420 }}>
                Oyuncu profili ve sosyal özellikler üzerinde çalışıyoruz.
                Çok yakında burada olacak!
            </p>
            <Link to="/" className="btn btn-primary rounded-pill px-4 mt-2 fw-bold">
                Ana Sayfaya Dön
            </Link>
        </div>
    );
};

export default ComingSoon;
